import { useState, useCallback } from 'react'

const KEY = 'lr-cookie-consent'

export function useConsent() {
  const [consent, setConsent] = useState(() => localStorage.getItem(KEY))

  const acceptAll = useCallback(() => {
    localStorage.setItem(KEY, 'all')
    setConsent('all')
  }, [])

  const acceptNecessary = useCallback(() => {
    localStorage.setItem(KEY, 'necessary')
    setConsent('necessary')
  }, [])

  return { consent, acceptAll, acceptNecessary }
}
